'use strict';

require('../modules/forms/forms');
require('./partnerFromUserForm');
require('../models/discipline/discipline');
require('../models/competition/competitionType');
require('../models/partners/partners');
require('../helpers/show-modal-message/show-modal-message');

angular.module('far.forms.competitionReportForm', [
        'dekky.forms',
        'far.forms.partnerFromUserForm',
        'far.models.discipline',
        'far.models.competition.competitionType',
        'far.models.partners',
        'far.helpers.showModalMessage'
    ])
    .service('competitionReportForm', function (form, partnerFromUserForm, fileUploadFilters, Discipline, partners, showModalMessage, autocomplete, CompetitionType) {
        var competitionReportForm = form('competitionReportForm');
        var competitionTypeList = CompetitionType.list;

        competitionReportForm
            .addField('participants_male', null, {
                validators: {
                    required: true,
                    numericOnly: '',
                    class: 'form__item width-50'
                }
            })
            .addField('participants_female', null, {
                validators: {
                    required: true,
                    numericOnly: '',
                    class: 'form__item width-50'
                }
            })
            .addField('safety', 'userSelect', {
                validators: {
                    required: true
                },
                options: {
                    class: 'form__ui-select'
                },
                uiSelectOptions: {
                    match: {
                        placeholder: 'Ответственный за безопасность, ФИО'
                    },
                    choices: {
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "safety")'
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete
                }
            }, autocomplete.get('safety'))
            .addField('judge', 'userSelect', {
                validators: {
                    required: true
                },
                options: {
                    class: 'form__ui-select'
                },
                uiSelectOptions: {
                    match: {
                        placeholder: 'Судья, ФИО'
                    },
                    choices: {
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "judge")'
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete
                }
            }, autocomplete.get('judge'))
            .addField('winner', 'userSelect', {
                validators: {
                    required: false
                },
                options: {
                    class: 'form__ui-select'
                },
                uiSelectOptions: {
                    match: {
                        placeholder: 'ФИО',
                        allowClear: true
                    },
                    choices: {
                        refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "winner")'
                    },
                    refreshAutoComplete: autocomplete.refreshAutoComplete
                }
            }, autocomplete.get('winner'))
            .addField('documentsFiles', 'fileUpload', {
                validators: {
                    required: false
                },
                label: 'Загрузить файл',
                uploader: {
                    url: Routing.generate('api_upload_post_file'),
                    autoUpload: true,
                    filters: [
                        fileUploadFilters.fileSize(),
                        fileUploadFilters.fileType()
                    ],
                    onSuccessItem: function (item, response) {
                        item.serverData = response;
                    },
                    onWhenAddingFileFailed: function (item, filter) {
                        var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
                        showModalMessage(message);
                    }
                }
            });

        return competitionReportForm;
    });
